import React from 'react';
import SkipToContent, {SkipToContentProvider} from '../SkipToContent';
import {ImpostorModeProvider} from 'src/components/ImpostorModeContext';
import {RaiseEventListenerProvider} from 'src/components/raise-event-listener-context';
import FeatureInteractionModals from '../feature-interaction-modals/feature-interaction-modals';

export interface ApplicationRootProps {
  children: React.ReactNode;
}

const ApplicationRoot = ({children = []}: ApplicationRootProps) => (
  <SkipToContentProvider>
    <ImpostorModeProvider>
      <RaiseEventListenerProvider>
        <FeatureInteractionModals />
        <SkipToContent />
        {children}
      </RaiseEventListenerProvider>
    </ImpostorModeProvider>
  </SkipToContentProvider>
);

export default ApplicationRoot;
